export default __webpack_public_path__ + "static/media/logo.7a0df0d3.svg";